import { useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { WHO } from "../../data/finder";
import { CourseFinder } from "./CourseFinder";

export const InlineFinder = ({ onClose }) => {
  const [who, setWho] = useState(null);
  return (
    <div data-testid="inline-finder" className="grid gap-5">
      <button type="button" data-testid="inline-finder-close" onClick={onClose} className="tap self-start inline-flex items-center gap-1.5 text-sm font-semibold muted hover:text-[#161616]"><ArrowLeft size={15} />Zurück zum Formular</button>
      {!who ? (
        <div>
          <p className="text-xs font-head font-semibold uppercase tracking-wide text-[#8A0093]">Frage 1 von 3</p>
          <h3 className="h-display text-2xl mt-1">Was möchtest du für dich tun?</h3>
          <div className="mt-4 grid gap-2" role="radiogroup">
            {Object.entries(WHO).map(([id, w]) => (
              <button key={id} type="button" role="radio" aria-checked={false} data-testid={`inline-finder-who-${id}`} onClick={() => setWho(id)}
                className="tap flex items-center justify-between gap-3 rounded-2xl border border-[#E6E3DD] bg-white px-4 py-3.5 text-left font-head font-semibold hover:border-[#161616] transition-colors">
                {w.label}<ArrowRight size={16} className="shrink-0 text-[#BA00C5]" />
              </button>
            ))}
          </div>
        </div>
      ) : <CourseFinder who={who} onReset={() => setWho(null)} />}
    </div>
  );
};
